export default __webpack_public_path__ + "static/media/widget15-img.98b7971c.png";